import { computed } from "vue";

import { useSettingsStore } from "@/stores";
import type { Font } from "@/types/site";

export function useArticleFont() {
  const settingsStore = useSettingsStore();

  const articleFont = computed<Font>(() => settingsStore.userPreferences.articleFont);
  const articleFontClass = computed<string>(() => `fonts__${articleFont.value}`);
  const arabicArticleFontClass = computed<string>(() => `arabic-fonts__${articleFont.value}`);

  return {
    articleFont,
    articleFontClass,
    arabicArticleFontClass
  };
}
